import axios from "axios";
import { getCodeLetter } from "./dataFormatter";
export class ApiClient {
  constructor() {
    this.baseUrl = "https://data-ecp.clarin.com/clarin.com";
    this.timeout = 10000;
  }

  /**
   * Obtener datos de elección
   */
  async fetchElectionData(params) {
    const url = this.buildApiUrl(params);
    try {
      const response = await axios({
        method: 'get',
        url,
        timeout: this.timeout,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });

      return {
        code: response.status,
        data: response.data
      };

    } catch (error) {
      console.error("Error fetching election data:", error.message, url);
      
      if (error.response) {
        return {
          code: error.response.status,
          data: error.response.data,
          error: error.message
        };
      }
      
      return {
        code: 500,
        data: null,
        error: error.message
      };
    }
  }
// https://data-ecp.clarin.com/clarin.com/2025/argentina/general/AR_delegatesprov.json
  /**
   * Construir URL de API
   */
  buildApiUrl(params) {
    const { year, electionInstance, resultPath, endpoint, typeElection } = params;
    // aceptar tanto apiAutomatic como apiUtomatic (por si viene con typo)
    const apiAutomatic = true;
    const codeLetter = getCodeLetter(resultPath);

    let baseUrl = this.baseUrl;

    // si apiAutomatic true usar ruta específica
    let url;
    if (apiAutomatic) {
      // usar siempre "argentina/api-automatic/general/" y luego el recurso
      url = `${baseUrl}/${year}/argentina/general/${codeLetter}_${endpoint}`;
    } else {
      // URL estándar para presidente/gobernador (puede ser 'general' o 'balotaje')
      url = `${baseUrl}/${year}/argentina/${electionInstance}/${codeLetter}_${endpoint}`;

      // Casos especiales para legislativas/delegados/senadores
      if (typeElection === 'legislativas') {
        url = `${baseUrl}/${year}/argentina/general/AR-C_delegatesprov.json`;
      }

      if (typeElection === 'senadores') {
        url = `${baseUrl}/${year}/argentina/generales/${codeLetter}_senators.json`;
      }

      if (typeElection === 'diputados') {
        url = `${baseUrl}/${year}/argentina/generales/${codeLetter}_delegates.json`;
      }
    }

    // si es apiAutomatic, agregar ?rv=<timestamp> (o & si ya hay query)
    if (apiAutomatic) {
      const ts = Date.now();
      url += (url.includes('?') ? '&' : '?') + `rv=${ts}`;
    }
    return url;
  }

  /**
   * Obtener datos de provincias para sitemap
   */
  async fetchProvincesData(year, electionInstance, code) {
    const url = `${this.baseUrl}/${year}/argentina/${electionInstance}/${code}_president.json`;
    return this.fetchData(url);
  }

  /**
   * Obtener datos de diputados (solo para Argentina - código AR)
   */
  async fetchBlocksNationalData(year, typeElection) {
    let url
    if(typeElection == "diputados"){
      url = `${this.baseUrl}/${year}/argentina/api-automatic/general/AR_delegates.json`;
    }else{
      url = `${this.baseUrl}/${year}/argentina/api-automatic/general/AR_senators.json`;
    }
    const ts = Date.now();
    url += (url.includes('?') ? '&' : '?') + `rv=${ts}`;
    const response = await this.fetchData(url);
    return response.data || [];
  }

  /**
   * Método genérico para fetch
   */
  async fetchData(url) {
    try {
      const response = await axios.get(url, { timeout: this.timeout });
      return {
        code: response.status,
        data: response.data
      };
    } catch (error) {
      return {
        code: error.response?.status || 500,
        data: null,
        error: error.message
      };
    }
  }
}